class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static freeShippingText = window.free_shipping_text.free_shipping_message;
    static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
    static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
    static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
    static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';
    static freeshipPrice = parseInt(window.free_shipping_price);

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.shipVal = window.free_shipping_text.free_shipping_1;
        this.progressMeter = this.querySelector('[ data-free-shipping-progress-meter]');

        this.addEventListener('change', this.onCartChange.bind(this));

        this.initialize();
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        })
    }

    onCartChange(e) {
        this.initialize();
    }

    calculateProgress(cart) {
        let totalPrice = cart.total_price;
        if ($('body').hasClass('setup_shipping_delivery')) {
            const giftCardItems = $(".cart-item[data-price-gift-card], .previewCartItem[data-price-gift-card]");
            if (giftCardItems.length > 0) {
                giftCardItems.each(function() {
                    totalPrice -= parseFloat($(this).attr("data-price-gift-card"));
                });
            }
        }
        const cartTotalPrice = parseInt(totalPrice) / 100;
        const cartTotalPriceFormatted = cartTotalPrice.toFixed(2);
        const cartTotalPriceRounded = parseFloat(cartTotalPriceFormatted);

        let freeShipBar = Math.abs((cartTotalPriceRounded * 100) / FreeShippingMeter.freeshipPrice);
        if (freeShipBar >= 100) {
            freeShipBar = 100;
        }
        
        const text = this.getText(cartTotalPriceFormatted, freeShipBar);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    getText(cartTotalPrice, freeShipBar) {
        let text;

        if (cartTotalPrice == 0) {
            this.progressBar.classList.add('progress-hidden');
            text = '<span>' + FreeShippingMeter.freeShippingText + ' ' + Shopify.formatMoney(FreeShippingMeter.freeshipPrice * 100, window.money_format) +' üzeri siparişlerde ücretsiz kargo.</span>';
        } else if (cartTotalPrice >= FreeShippingMeter.freeshipPrice) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;
            text = FreeShippingMeter.freeShippingText1;
        } else {
            this.progressBar.classList.remove('progress-hidden');
            const remainingPrice = Math.abs(FreeShippingMeter.freeshipPrice - cartTotalPrice);
            text = '<span>' + FreeShippingMeter.freeShippingText2 + ' </span>' + Shopify.formatMoney(remainingPrice * 100, window.money_format) + '<span> ' +  FreeShippingMeter.freeShippingText3 + ' </span><span class="text">' + FreeShippingMeter.freeShippingText4 + '</span>';
            this.shipVal = window.free_shipping_text.free_shipping_2;
        }

        return text;
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else  if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free'
        }

        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-100');
        this.progressBar.classList.remove('progress-free');

        this.progressBar.classList.add(classLabel);
    }
    
    setProgressWidthAndText(freeShipBar, text, classLabel) {
        setTimeout(() => {
            this.resetProgressClass(classLabel);

            this.progressMeter.style.width = `${freeShipBar}%`;
            if (this.textEnabled) {
                const textWrapper = this.progressMeter.querySelector('.text').innerHTML = `${freeShipBar.toFixed(2)}%`;
            }

            this.messageElement.innerHTML = text;

            if($('.dropdown-item[data-currency]').length){
                if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                    Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                }
            }
        }, 400)
    }
}

window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
})

class CartDiscountMeter extends HTMLElement {

        static enableSecondTier = false;

    constructor() {
        super();

        this.handleCartChange = this.handleCartChange.bind(this);
        this.handleCartClick = this.handleCartClick.bind(this);
    }

    connectedCallback() {
        this.firstBar = this.querySelector('[data-discount-bar-10]');
        this.firstMeter = this.querySelector('[data-discount-meter-10]');
        this.firstMessage = this.querySelector('[data-discount-message-10]');

        this.secondBar = this.querySelector('[data-discount-bar-15]');
        this.secondMeter = this.querySelector('[data-discount-meter-15]');
        this.secondMessage = this.querySelector('[data-discount-message-15]');

        document.addEventListener('change', this.handleCartChange);
        document.addEventListener('click', this.handleCartClick);

        this.initialize();
    }

    disconnectedCallback() {
        document.removeEventListener('change', this.handleCartChange);
        document.removeEventListener('click', this.handleCartClick);
    }

    handleCartChange() {
        setTimeout(() => {
            this.initialize();
        }, 600);
    }

    handleCartClick(event) {
        if (
            event.target.closest('.quantity__button') ||
            event.target.closest('.qty-btn') ||
            event.target.closest('.quantity button') ||
            event.target.closest('cart-remove-button') ||
            event.target.closest('[data-cart-remove]') ||
            event.target.closest('[name="plus"]') ||
            event.target.closest('[name="minus"]')
        ) {
            setTimeout(() => {
                this.initialize();
            }, 700);
        }
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.updateMeters(cart.item_count);
        });
    }

setProgressColor(step, meter, percentage) {
    step.classList.remove(
        'progress-red',
        'progress-orange',
        'progress-light-green',
        'progress-green'
    );

    meter.classList.remove(
        'progress-red',
        'progress-orange',
        'progress-light-green',
        'progress-green'
    );

    let colorClass = 'progress-red';

    if (percentage >= 100) {
        colorClass = 'progress-green';
    } else if (percentage >= 65) {
        colorClass = 'progress-light-green';
    } else if (percentage >= 35) {
        colorClass = 'progress-orange';
    }

    step.classList.add(colorClass);
    meter.classList.add(colorClass);
}

    updateMeters(quantity) {

        /* 5 ÜRÜN = EKSTRA %10 */

        let firstPercentage = (quantity / 5) * 100;

        if (firstPercentage > 100) {
            firstPercentage = 100;
        }

        if (quantity >= 5) {

            this.firstMessage.innerHTML =
                '<strong>Ekstra %10 indirimi kazandınız!</strong>';

        } else {

            const remainingFirst = 5 - quantity;

            this.firstMessage.innerHTML =
                'Ekstra %10 indirim için <strong>son ' +
                remainingFirst +
                ' ürün kaldı!</strong>';
        }

        this.firstMeter.style.width = firstPercentage + '%';

        this.setProgressColor(
        this.firstBar,
        this.firstMeter,
        firstPercentage
);


        /* 8 ÜRÜN = EKSTRA %15 */

        if (!CartDiscountMeter.enableSecondTier) {
    this.secondBar.style.display = 'none';
    this.secondMeter.style.width = '0%';
    return;
}


        if (quantity >= 5) {

            this.secondBar.style.display = 'block';

            let secondPercentage = ((quantity - 5) / 3) * 100;

            if (secondPercentage < 0) {
                secondPercentage = 0;
            }

            if (secondPercentage > 100) {
                secondPercentage = 100;
            }

            if (quantity >= 8) {

                this.secondMessage.innerHTML =
                    '<strong>Ekstra %15 indirimi kazandınız!</strong>';

            } else {

                const remainingSecond = 8 - quantity;

                this.secondMessage.innerHTML =
                    'Ekstra %15 indirim için <strong>son ' +
                    remainingSecond +
                    ' ürün kaldı!</strong>';
            }

            this.secondMeter.style.width = secondPercentage + '%';

            this.setProgressColor(
    this.secondBar,
    this.secondMeter,
    secondPercentage
);

        } else {

            this.secondBar.style.display = 'none';
            this.secondMeter.style.width = '0%';
        }
    }
}

if (!customElements.get('cart-discount-meter')) {
    customElements.define('cart-discount-meter', CartDiscountMeter);
}